import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { SalesforceUserSelector } from '@ui/SalesforceUserSelector';
import React, { useCallback } from 'react';
export const ModifiedByFilter = ({ disabled, onChange, value }) => {
    const handleOnChange = useCallback((modifiedByUsernames) => {
        onChange({ modifiedByUsernames });
    }, [onChange]);
    return (React.createElement(SalesforceUserSelector, { allowReadonly: true, disabled: disabled, onChange: handleOnChange, placeholder: COPY_SPECIFIC.SELECT_ADMIN, value: value }));
};
